import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useRef } from "react";
import "../Components/Servicespage.css";
import { db } from "../firebase-config";
import { collection, query, where, getDocs } from "firebase/firestore";
import CircularProgress from "@mui/material/CircularProgress";
const Servicespages = () => {
  const swiperRef = useRef(null);
  const [services, sethServices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "Services")
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        sethServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);
  // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }
  return (
    <div className="services-wrapper">
      <div className="services-header">
        <div className="services-header-left">
          <div className="services-vertical-line"></div>
          <h2>Our Services in Major Cities</h2>
        </div>
        <div className="services-header-right">
          <button
            className="services-nav-btn"
            onClick={() => swiperRef.current.slidePrev()}
          >
            <FaArrowLeft />
          </button>
          <button
            className="services-nav-btn"
            onClick={() => swiperRef.current.slideNext()}
          >
            <FaArrowRight />
          </button>
        </div>
      </div>
      <Swiper
        modules={[Navigation]}
        spaceBetween={25}
        slidesPerView={3}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {services?.map((service, index) => (
          <SwiperSlide key={index}>
            <div
              className="services-card"
              style={{ backgroundImage: `url(${service.image})` }}
            >
              <div className="services-card-content">
                {service.description}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Servicespages
